import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import DataService from 'lib/DataService';

import Loading from 'components/Loading';

import {
	LoginContainer,
	LoginForm,
	Logo,
} from '../Login';

import EmailForm from './EmailForm';
import PasswordForm from './PasswordForm';

const logo = require(`!raw-loader!../../assets/${'logo'}.svg`);

const BackToLogin = styled(Link)`
	color: rgba(74,144,226,1);
`;

const API = new DataService();

class ForgotPassword extends React.Component {
	state = {
	  token: null,
	  username: '',
	  password: '',
	  viewPassword: false,
	  loading: false,
	  requesting: false,
	  emailSent: false,
	  passwordChanged: false,
	  error: null,
	}

	componentDidMount() {

	  this.mounted = true;

	  API.getStageToken()
	    .then(token => {
	      if (this.mounted) {
	        this.setState({ token });
	      }
	    });

	}

	componentWillUnmount() {
	  this.mounted = false;
	}

	handleInputChange = event => {
	  this.setState({
	    [event.target.name]: event.target.value,
	    error: null,
	  });
	}

	handleInputBlur = event => {
	  this.setState({
	    [event.target.name]: event.target.value
	  });
	}

	handleViewPassword = () => this.setState({ viewPassword: !this.state.viewPassword });

	handleSubmit = event => {
	  if (!this.state.requesting) {
	    this.setState({ requesting: true });

	    let resetToken = false;

	    if ('resetToken' in this.props.match.params) {
	      resetToken = this.props.match.params.resetToken;
	    }

	    if (resetToken) {
	      // Change password
	      API.changePassword({
	        token: resetToken,
	        newPassword: this.state.password,
	        newPasswordConfirm: this.state.password,
	      }).then(response => {
	        if (response.result.changePassword) {
	          this.setState({
	            requesting: false,
	            passwordChanged: true,
	          });
	        } else {
	          this.setState({
	            requesting: false,
	            error: 'error/token error',
	          });
	        }
	      }).catch(error => {
	        console.log(error)
	      })
	    } else {
	      // Request password change
	      API.requestForgottenPasswordEmail({
	        token: this.state.token,
	        username: this.state.username
	      }).then(response => {
	        if (response.result.forgotPassword) {
	          this.setState({
	            requesting: false,
	            emailSent: true,
	          });
	        } else {
	          this.setState({
	            requesting: false,
	            error: 'error',
	          });
	        }
	      });
	    }
	  }
	}

	render() {
	  const { t, lng } = this.props;
	  const emailButtonText = this.state.requesting ? t('login/Requesting a new password...') : t('login/Request a new password');
	  const passwordButtonText = this.state.requesting ? t('login/Setting new password...') : t('login/Set new password');

	  let resetToken = false;

	  if ('resetToken' in this.props.match.params) {
	    resetToken = this.props.match.params.resetToken;
	  }

	  return this.state.token === null
	    ? <Loading />
	    : (
	      <LoginContainer>
	        <LoginForm method="POST" onSubmit={event => { event.preventDefault(); this.handleSubmit(event)}}>
	          <Logo dangerouslySetInnerHTML={{__html: logo }} />

	          { resetToken
	            ? <PasswordForm
	              passwordChanged={this.state.passwordChanged}
	              error={this.state.error}
	              password={this.state.password}
	              viewPassword={this.state.viewPassword}
	              buttonText={passwordButtonText}
	              handleInputBlur={this.handleInputBlur}
	              handleInputChange={this.handleInputChange}
	              handleViewPassword={this.handleViewPassword}
	              t={t}
	            />
	            : <EmailForm
	              emailSent={this.state.emailSent}
	              error={this.state.error}
	              username={this.state.username}
	              buttonText={emailButtonText}
	              handleInputBlur={this.handleInputBlur}
	              handleInputChange={this.handleInputChange}
	              t={t}
	            />
	          }
	        </LoginForm>
	        <BackToLogin to={`/${lng}/t/login/`}>{t('login/back to login')}</BackToLogin>
	      </LoginContainer>
	    )
	}
}

ForgotPassword.propTypes = {
	t: PropTypes.func,
	lng: PropTypes.string,
	match: PropTypes.object,
}

export default translate('translations')(ForgotPassword)
